// ============================================================
// ChatLog — Nachrichtenliste des Assistenten-Panels (React-Insel).
// Ersetzt die DOM-Appends addMsg()/addOfferCard() aus AssistantBar.js;
// die Daten kommen aus engine.messages, CSS-Klassen unverändert.
// ============================================================
import { useEffect, useLayoutEffect, useState, type RefObject } from 'react';
import { useTranslation } from '../../lib/useTranslation.ts';
import type { AssistantEngine } from '../../../components/assistant-bar/engine/AssistantEngine.ts';
import { authedFetch, VOICE_PREVIEW_BASE } from '../../../components/assistant-bar/engine/api.ts';

interface OfferCardProps {
  engine: AssistantEngine;
  offerId: string;
  offerNumber: string;
}

function OfferCard({ engine, offerId, offerNumber }: OfferCardProps) {
  const t = useTranslation();
  const [src, setSrc] = useState('');
  // token-e kotah-omr begir, bad src-e iframe ra set kon (iframe header nemifrestad)
  // (Der Fetch lief früher direkt beim Anhängen der Karte in addOfferCard —
  // jetzt beim Mount der Karte; gleicher Endpunkt, gleicher Ablauf.)
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const tr = await authedFetch(VOICE_PREVIEW_BASE + '-token', {
          method: 'POST', body: JSON.stringify({ offer_id: offerId }),
        });
        const td = await tr.json();
        if (alive && td.success && td.token) {
          setSrc(VOICE_PREVIEW_BASE + '/' + offerId + '?token=' + encodeURIComponent(td.token));
        }
      } catch { /* preview optional */ }
    })();
    return () => { alive = false; };
  }, [offerId]);
  return (
    <div className="ab-offer-card">
      <div className="ab-offer-head">
        <span className="ab-offer-badge">{t('assistant.docOffer')}</span>
        <span className="ab-offer-num">{offerNumber}</span>
      </div>
      <div className="ab-offer-preview">
        {/* visualsPaused: früher pauseVisualsForForm() → display:none auf allen
            .ab-offer-frame, damit das iframe nicht über dem Formular liegt. */}
        <iframe
          className="ab-offer-frame"
          data-oid={offerId}
          loading="lazy"
          style={engine.visualsPaused ? { display: 'none' } : undefined}
          {...(src ? { src } : {})}
        />
      </div>
    </div>
  );
}

interface ChatLogProps {
  engine: AssistantEngine;
  chatRef: RefObject<HTMLDivElement>;
}

export function ChatLog({ engine, chatRef }: ChatLogProps) {
  // Scroll ans Ende exakt dann, wenn der alte Code chat.scrollTop setzte
  // (chatScrollTick zählt genau diese Stellen).
  useLayoutEffect(() => {
    const el = chatRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [engine.chatScrollTick, chatRef]);

  return (
    <div className={'ab-chat' + (engine.panelView === 'voice' ? ' ab-hide' : '')} id="ab-chat" ref={chatRef}>
      {engine.messages.map((m) => (
        m.kind === 'offer'
          ? <OfferCard key={m.id} engine={engine} offerId={m.offerId} offerNumber={m.offerNumber} />
          : <div key={m.id} className={'ab-msg ab-msg-' + m.who}>{m.text}</div>
      ))}
    </div>
  );
}
